import React from "react";

interface Props {
  children: string;
}

const Headers = ({ children }: Props) => {
  return <div className="text_heading">{children}</div>;
};

export default Headers;
